import React from 'react'

export function CloudBackground() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 1999 454"
      preserveAspectRatio="none"
    >
      <path
        fill="#EFF6FF"
        d="M824.001 403L875.501 422H1999V63.1446C1977.5 77.3383 1961.18 93.6986 1958 93.5001C1950 93.0001 1946 25.5001 1846 11.5001C1746 -2.49994 1705.5 70.0001 1698.5 69.5001C1691.5 69.0001 1678 -0.499932 1559 0.500068C1440 1.50007 1439.5 117 1432.5 119.5C1425.5 122 1363.5 79.0001 1292 113.5C1220.5 148 1244.5 212 1237.5 216C1230.5 220 1191 172 1106.5 198.5C1022 225 1035 289 1024 291C1013 293 967.001 231.5 875.501 278C784.001 324.5 824.001 403 824.001 403Z"
      ></path>
      <path
        fill="#DBEAFE"
        d="M925.5 340.5C1010.5 364.432 1005.5 408.5 1005.5 408.5L1065.5 451.5H0V281.079C15.5746 272.042 39.5753 264.56 70.5013 260.5C200.001 243.5 219.003 293.5 227.501 292C236 290.5 257.001 219.5 387.501 233C518.001 246.5 530.002 317.5 540.501 319C551 320.5 601.502 263 695.001 283.5C788.5 304 788.502 352.5 796.501 354.5C804.5 356.5 840.501 316.568 925.5 340.5Z"
      ></path>
    </svg>
  )
}
